var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08203 5.74349C2.08203 3.90254 3.57442 2.41016 5.41536 2.41016C7.25631 2.41016 8.7487 3.90254 8.7487 5.74349C8.7487 7.58444 7.25631 9.07682 5.41536 9.07682C3.57442 9.07682 2.08203 7.58444 2.08203 5.74349Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.25 14.9105C11.25 13.0695 12.7424 11.5771 14.5833 11.5771C16.4243 11.5771 17.9167 13.0695 17.9167 14.9105C17.9167 16.7514 16.4243 18.2438 14.5833 18.2438C12.7424 18.2438 11.25 16.7514 11.25 14.9105Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08203 14.9105C2.08203 13.3391 2.08203 12.5535 2.57019 12.0653C3.05834 11.5771 3.84402 11.5771 5.41536 11.5771C6.98671 11.5771 7.77239 11.5771 8.26054 12.0653C8.7487 12.5535 8.7487 13.3391 8.7487 14.9105C8.7487 16.4818 8.7487 17.2675 8.26054 17.7557C7.77239 18.2438 6.98671 18.2438 5.41536 18.2438C3.84402 18.2438 3.05834 18.2438 2.57019 17.7557C2.08203 17.2675 2.08203 16.4818 2.08203 14.9105Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.25 5.74349C11.25 4.17214 11.25 3.38647 11.7382 2.89831C12.2263 2.41016 13.012 2.41016 14.5833 2.41016C16.1547 2.41016 16.9404 2.41016 17.4285 2.89831C17.9167 3.38647 17.9167 4.17214 17.9167 5.74349C17.9167 7.31484 17.9167 8.10051 17.4285 8.58867C16.9404 9.07682 16.1547 9.07682 14.5833 9.07682C13.012 9.07682 12.2263 9.07682 11.7382 8.58867C11.25 8.10051 11.25 7.31484 11.25 5.74349Z",
    stroke: "#858585",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/CategoryIcon.4883f44209882f39f78283c3024141cf.svg";
export { ForwardRef as ReactComponent };